import { PlusCircleFilled } from '@ant-design/icons';
import { filter } from 'lodash';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EPCheckbox } from '@/comp';
import EPTierTooltip from '@/comp/common/EPTierTooltip';
import { ComponentTierName, interestedPackageEnum } from '@/constants/enums';
import { PanelWrapperProps } from '@/constants/panelWrapperType';
import { useStores } from '@/hooks/use-stores';
import { useInvestigationMetricSelection } from '@/hooks/useInvestigationMetricSelection';
import { checkTierPermission } from '@/utils/util-functions';

import { TierProtectionPanel } from './styled';

const PressureDropDevicesCollapsable: React.FC<PanelWrapperProps> = observer(props => {
  const { canSelectMetric, ...restProps } = props;
  const { investigationStore, stationStore } = useStores();
  const { t } = useTranslation();
  const { selectPressureDrop } = useInvestigationMetricSelection();
  const [isTierRequestConfirmationModalOpen, setIsTierRequestConfirmationModalOpen] = useState(false);
  const shouldRestrictInvestigationDashboard = checkTierPermission(
    ComponentTierName.InvestigationDashboard,
    stationStore,
  );

  const totalSelected = filter(investigationStore.pressureDrops, {
    isSelected: true,
  }).length;

  const onClickHereHandler = () => {
    stationStore.updateRequestTier({
      emailRequestTypeOfInterestedPackage: interestedPackageEnum.PRESSURE_DROP,
      emailRequestButtonClicked: '-+ button',
      emailRequestWhichScreen: 'Investigation',
    });
    setIsTierRequestConfirmationModalOpen(true);
  };

  const extra = shouldRestrictInvestigationDashboard ? (
    <EPTierTooltip
      textPart2={t('addPressureSensorPack')}
      tooltipPlacement="bottom"
      tooltipWidth={330}
      initialIsTierRequestModalOpen={isTierRequestConfirmationModalOpen}
      emailRequestTypeOfInterestedPackage={interestedPackageEnum.PRESSURE_DROP}
      emailRequestButtonClicked={'tooltip  Pressure Drop'}
      emailRequestWhichScreen={'Investigation'}
    >
      <div onClick={onClickHereHandler} className="tier-plus-icon">
        <PlusCircleFilled />
      </div>
    </EPTierTooltip>
  ) : (
    <span className="selected-counter">
      {totalSelected}/{investigationStore.pressureDrops.length}
    </span>
  );

  const onCheckPressureDrop = (e, pressureDropId) => {
    if (canSelectMetric(e)) {
      selectPressureDrop(pressureDropId, e.target.checked);
    }
  };

  return (
    (investigationStore.pressureDrops.length > 0 || shouldRestrictInvestigationDashboard) && (
      <TierProtectionPanel
        {...restProps}
        header={t('Pressure drop')}
        extra={extra}
        collapsible={shouldRestrictInvestigationDashboard ? 'disabled' : null}
        $shouldRestrictInvestigationDashboard={shouldRestrictInvestigationDashboard}
      >
        {investigationStore.pressureDrops.map(pressureDrop => (
          <div key={pressureDrop.key}>
            <EPCheckbox checked={pressureDrop.isSelected} onChange={e => onCheckPressureDrop(e, pressureDrop.id)}>
              {pressureDrop.name}
            </EPCheckbox>
          </div>
        ))}
      </TierProtectionPanel>
    )
  );
});

export default PressureDropDevicesCollapsable;
